export function parseProductCloneInfo(text) {
    const lines = text
        .split(/\r?\n/)
        .map((l) => l.trim())
        .filter(Boolean);
    if (lines.length < 2)
        return null;
    const [firmware, model] = lines;
    if (!/^T-[A-Z0-9]+-\d{4}[-_]\d+(\.\d+)?$/i.test(firmware))
        return null;
    if (!/^[A-Z0-9]{3,16}$/i.test(model))
        return null;
    return { firmware: firmware.toUpperCase(), model: model.toUpperCase() };
}
export function firmwareFamily(firmware) {
    const m = /^(T-[A-Z0-9]+-\d{4})[-_]/i.exec(firmware.trim());
    return (m ? m[1] : firmware.trim()).toUpperCase();
}
export function seriesMatchesModel(series, deviceModel) {
    const s = series.trim().toUpperCase();
    const d = deviceModel.trim().toUpperCase();
    if (!s || !d)
        return false;
    if (s === d)
        return true;
    const body = s.replace(/^H/, "");
    const m = /^([A-Z]*)(\d+)([A-Z]?)$/.exec(body);
    if (!m)
        return false;
    const digits = m[2].length === 4 && m[2].endsWith("0") ? m[2].slice(0, 3) : m[2];
    return d.includes(`${m[1]}${digits}${m[3]}`);
}
function compareBuild(a, b) {
    const num = (f) => {
        const m = /[-_](\d+(?:\.\d+)?)$/.exec(f);
        return m ? Number(m[1]) : NaN;
    };
    return num(a) - num(b);
}
export function cloneCompatibility(clone, device) {
    var _a, _b;
    const model = (_a = device.model) === null || _a === void 0 ? void 0 : _a.trim();
    const firmware = (_b = device.firmware) === null || _b === void 0 ? void 0 : _b.trim().toUpperCase();
    if (!model || !firmware) {
        return {
            ok: false,
            code: "device_unknown",
            message: "This TV has not reported its model and firmware yet, so Foyer cannot check that the clone fits.",
            resolution: "Make sure the TV is on and running Foyer, then press Refresh telemetry. The model and firmware appear on the device page within a minute.",
        };
    }
    if (!seriesMatchesModel(clone.model, model)) {
        return {
            ok: false,
            code: "model_mismatch",
            message: `This clone was made on a ${clone.model}; this TV is a ${model}.`,
            resolution: `Samsung only restores a clone onto the same model. Make a clone on a ${model} (Hotel Option → Cloning → Clone TV to USB) and upload that folder to this premise.`,
        };
    }
    if (clone.firmware !== firmware) {
        const cmp = compareBuild(firmware, clone.firmware);
        const sameFamily = firmwareFamily(firmware) === firmwareFamily(clone.firmware);
        return {
            ok: false,
            code: "firmware_mismatch",
            message: `This clone was made on firmware ${clone.firmware}; this TV runs ${firmware}.`,
            resolution: sameFamily && cmp < 0
                ? `Samsung only restores a clone onto the same firmware. Upgrade this TV to ${clone.firmware} first (OTA → firmware rollout), then restore the clone.`
                : sameFamily && cmp > 0
                    ? `Samsung only restores a clone onto the same firmware, and firmware cannot be downgraded. Upgrade the reference TV to ${firmware}, make a new clone (Hotel Option → Cloning → Clone TV to USB) and upload it.`
                    : `Samsung only restores a clone onto the same firmware. Bring both TVs to the same version, then make a new clone on the reference TV and upload it.`,
        };
    }
    return { ok: true };
}
